var mobileTrigger = $(window).innerWidth() < 992;

$(document).ready(function () {

    $('#cryptoRows-tab, #cryptoGrid-tab').each(function () {

        $(this).click(function () {
            const router = $(this).attr('id');

            if (router == 'cryptoGrid-tab') showGrid($(this));
            if (router == 'cryptoRows-tab') showRow($(this));

            function showGrid(btn) {
                $('#cryptoRows-tab').removeClass('d-none');
                $(btn).addClass('d-none');

                var animTl = gsap.timeline();

                gsap.fromTo('.hero-viewswrap', {
                    maxHeight: 100,
                },
                    {
                        maxHeight: 0,
                    });
            };

            function showRow(btn) {
                $('#rowFilter').removeClass('grid-shown');
                $('#cryptoGrid-tab').removeClass('d-none');
                $(btn).addClass('d-none');

                gsap.to('.hero-viewswrap', {
                    maxHeight: 100,
                });
            };
        });

    })

    $('#toggleProducts').change(function () {
        const router = $(this).val();

        $(this).addClass('active').siblings('button').removeClass('active');

        switch (router) {
            case 'allProds':
                toggleAllProds();
                break;
            case 'diversified':
                toggleCryptoList();
                break;
            case 'single_asset':
                toggleCryptoList();
                break;
            case 'eqUcits':
                toggleEqUcits();
                break;
            default:
                break;
        };

        function toggleAllProds() {
            $('#etf, #cryptoList, [data-element=rowSelector]').removeClass('d-none');
        }

        function toggleCryptoList() {
            $('#cryptoList,  [data-element=rowSelector]').removeClass('d-none');
            $('#etf').addClass('d-none');
        }

        function toggleEqUcits() {
            $('#cryptoList, [data-element=rowSelector]').addClass('d-none');
            $('#etf').removeClass('d-none');
        }
    })
});

$(window).resize(function () {
    setLayoutType();
})

// if ($('#cryptosHeader').length) {
//     var cryptosHeader = $('#cryptosHeader').offset().top - $('#cryptosHeader').height();
// }

// $(document).scroll(function () {
//     if (cryptosHeader) {
//         let scrollY = $(document).scrollTop();
//         let visibleTh = $('#hero').outerHeight() - $('#cryptosHeader').outerHeight() * 2;
//         const productsBottom = $('#cryptoList').offset().top + $('#cryptoList').outerHeight() - $('#cryptosHeader').height();

//         if (scrollY > cryptosHeader) {
//             $('#hero').attr('style', `
//             position: sticky;
//             top: -${visibleTh}px
//             `)
//         } else {
//             $('#hero').attr('style', '');
//         }
//     }
// })

function setLayoutType() {
    let type = window.innerWidth < 992 ? 'mobile' : 'desktop';

    if (type == 'mobile') {
        $('#cryptoRows-tab').click();
    }
}